export default __webpack_public_path__ + "static/media/app-store-es.54b05045.svg";